import React, { Suspense, lazy } from 'react';

// Load only above-the-fold normally
import CompanySection from '../components/OurCompanySections/CompanySection';

// Lazy load below-the-fold sections
const OurStory = lazy(() => import('../components/OurCompanySections/OurStory'));
const MissionVisionSection = lazy(() => import('../components/OurCompanySections/MissionVisionSection'));
const ColdChainSection = lazy(() => import('../components/OurCompanySections/ColdChainSection'));
const InfoSection = lazy(() => import('../components/OurCompanySections/InfoSection'));
// If you enable it later
// const MilestoneChart = lazy(() => import('../components/OurCompanySections/MilestoneChart'));

const Company = () => {
  return (
    <div>
      {/* Above-the-fold content */}
      <CompanySection />

      {/* Lazy loaded content */}
      <Suspense fallback={<div>Loading...</div>}>
        <OurStory />
        <MissionVisionSection />
        <ColdChainSection />
        {/* <MilestoneChart /> */}
        <InfoSection />
      </Suspense>
    </div>
  );
};

export default Company;
